import { useEffect, useRef, useState } from "react";
import { KTSVG } from "../../_metronic/helpers";
import { useChatStore } from "../../stores/ChatStore";
import useAccessToken from "../../hooks/AccessToken";
import addNotification from "react-push-notification";
import { useNavigate } from "react-router-dom";
import useUser from "../../hooks/User";
import { useSettingsStore } from "../../stores/SettingsStore";
import Select, { components } from "react-select";
import { SelectOption } from "../../interfaces/SelectOption";
import axios from "axios";
import useSWR, { mutate } from "swr";
import { Progress } from "rsuite/esm/Progress/Progress";
import moment from 'moment';
import { useCustomeStore } from "../../stores/CustomeStore";
import { ChatList } from "./ChatList";
import { useIntl } from "react-intl";
import { AssignContactLabel } from "./Modal/AssignContactLabel";
import { LabelChatProps } from "../../interfaces/Chat/LabelChat";
import { chatMode, focusChatInput, generateColorChatPhone, isShowChatRoom, sortChatRooms, stringToColor } from "../../functions/chat";
import { useUserStore } from "../../stores/UserStore";
import { ChatAgent, ChatGroupMessage, ChatGroupParticipants, ChatGroupRoom, ChatMerchant, ChatMessage, ChatRoom, Condiments, GroupCondiments, ListChatGroupRoom, ListChatRoom } from "../../interfaces/Chat/Chat";
import { useChatSearch } from "../../hooks/useChatSearch";
import { ChatListSearch } from "./ChatListSearch";
import { isToday, parseISO } from "date-fns";
import useModalEffect from "../../hooks/useModalEffect";
import { ChatGroupList } from "./ChatGroupList";
import { useChatGroupSearch } from "../../hooks/useChatGroupSearch";
import { ChatGroupListSearch } from "./ChatGroupListSearch";
import { checkIsCompanyTanrise } from "../../functions/customCase";
import { formatText, generateTextColor } from "../../functions/general";
import { UpdateGroupMessageBubble } from "./Modal/UpdateGroupMessageBubble";

interface ChatSidebarProps {
    style: any
    handleIntSync: (isFirst: boolean, isNew: boolean, type: 'chat' | 'chat-group', dataRoom: ChatMessage | ChatGroupMessage) => void
}

const ChatSidebar = ({ style, handleIntSync }: ChatSidebarProps) => {
    const API_URL = process.env.REACT_APP_API_URL
    const user = useUser()
    const intl = useIntl()
    const token = useAccessToken()
    const { companyId } = useCustomeStore()

    const navigate = useNavigate()
    const {
        socket, connected, setShowChatGroup, tokenChat, phoneNumber,
        selectedChatPhone, menuActive, setListChatGroupRooms, setGroupMessages,
        setMessageNotifications, setPhoneNumber, setShowChat, isGroupFilterSidebar, setListChatGroupMessages,
        listChatRooms, setListChatMessages, setMessages, isFilterSidebar, setListFilterChatGroup,
        setListChatRooms, setListFilterChat, searchSidebar, searchGroupSidebar, setIsFilterSidebar,
        lastSynced, setSearchSidebar, setSearchGroupSidebar, isGroupSyncing, setIsGroupFilterSidebar,
        isSyncing, setIsOpenDetailContact, setMessage, setSelectChatGroupWindow, setGroupMessageNotifications,
        setSelectedChatPhone, isWaitingForNetwork, setMode, setGroupMode, selectChatGroupWindow,
        selectChatWindow, setSelectChatWindow, chatLabels, setMenuActive, setGroupID, setGroupMessage,
    } = useChatStore()
    const { settings } = useSettingsStore()
    const { users, userLoading } = useUserStore()

    const [statusData, setStatusData] = useState<SelectOption[]>([])
    const [statusSessionData, setStatusSessionData] = useState<SelectOption[]>([])
    const [progressesData, setProgressesData] = useState<SelectOption[]>([])
    const [labelsData, setLabelsData] = useState<SelectOption[]>([])
    const [picData, setPicData] = useState<SelectOption[]>([])
    const [selectedFilterProgress, setSelectedFilterProgress] = useState<string[]>([]);
    const [selectedFilterLabelGroup, setSelectedFilterLabelGroup] = useState<string>("");
    const [selectedFilterStatusGroup, setSelectedFilterStatusGroup] = useState<string>("");
    const [selectedFilterLabel, setSelectedFilterLabel] = useState<string>("");
    const [selectedFilterStatus, setSelectedFilterStatus] = useState<string>("");
    const [selectedFilterStatusSession, setSelectedFilterStatusSession] = useState<string[]>([]);
    const [selectedFilterPicMerchant, setSelectedFilterPicMerchant] = useState<string[]>([]);
    const [selectedFilterPicPipeline, setSelectedFilterPicPipeline] = useState<string[]>([]);
    const [selected, setSelected] = useState<{ [phone: string]: boolean }>({});
    const [showAssignContactLabelModal, setShowAssignContactLabelModal] = useState<boolean>(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);

    const handleChatNotification = async (incomingMessage: ChatRoom) => {
        try {
            addNotification({
                title: incomingMessage.roomName ?? incomingMessage.roomPhone,
                message: incomingMessage.chat.message,
                native: true, // when using native, your OS will handle theming.
                onClick: () => {
                    if (window.location.pathname !== '/chat') {
                        navigate('/chat');
                    }

                    const { messageNotifications, listChatMessages } = useChatStore.getState();
                    const key = `${incomingMessage.roomPhone}-${incomingMessage.as}`

                    setMessage('')
                    setIsOpenDetailContact(false)
                    if (listChatMessages[key] && listChatMessages[key].length > 0) {
                        setMessages(() => listChatMessages[key])
                    } else {
                        setMessages(() => [])
                    }

                    setListChatRooms((prevListChatRooms) => ({
                        ...prevListChatRooms,
                        [key]: {
                            ...prevListChatRooms[key],
                            selected: true
                        }
                    }));

                    const { [key]: removedItem, ...rest } = messageNotifications;
                    setShowChat(true)
                    setMenuActive('chat')
                    setPhoneNumber(key)
                    setMode('normal')
                    setMessageNotifications(() => rest);
                    focusChatInput()
                }
            });
        } catch (error) {
            console.log(error)
        }
    }

    const handleChatGroupNotification = async (incomingMessage: ChatGroupRoom) => {
        const { listChatGroupParticipants } = useChatStore.getState();

        try {
            addNotification({
                title: incomingMessage.groupName,
                message: formatText(incomingMessage.chat.message, listChatGroupParticipants, listChatRooms[phoneNumber], false, true),
                native: true, // when using native, your OS will handle theming.
                onClick: () => {
                    if (window.location.pathname !== '/chat') {
                        navigate('/chat');
                    }

                    const { groupMessageNotifications, listChatGroupMessages } = useChatStore.getState();
                    const key = `${incomingMessage.groupId}|${incomingMessage.as}`

                    setGroupMessage('')
                    setIsOpenDetailContact(false)
                    if (listChatGroupMessages[key] && listChatGroupMessages[key].length > 0) {
                        setGroupMessages(() => listChatGroupMessages[key])
                    } else {
                        setGroupMessages(() => [])
                    }

                    setListChatGroupRooms((prevListChatRooms) => ({
                        ...prevListChatRooms,
                        [key]: {
                            ...prevListChatRooms[key],
                            selected: true
                        }
                    }));

                    const { [key]: removedItem, ...rest } = groupMessageNotifications;
                    setShowChatGroup(true)
                    setMenuActive('chat-group')
                    setGroupID(key)
                    setMode('normal')
                    setGroupMessageNotifications(() => rest);
                    focusChatInput()
                }
            });
        } catch (error) {
            console.log(error)
        }
    }

    const handleFilterChange = (selectedOptions: SelectOption[] | SelectOption, type: string) => {
        if (menuActive === "chat") {
            if (type === "progress") {
                const selectedValues = (selectedOptions as SelectOption[]).map(option => option.value);
                setIsFilterSidebar(true);
                setSelectedFilterProgress(selectedValues);
            } else if (type === "picMerchant") {
                const selectedValues = (selectedOptions as SelectOption[]).map(option => option.value);
                setIsFilterSidebar(true);
                setSelectedFilterPicMerchant(selectedValues);
            } else if (type === "picPipeline") {
                const selectedValues = (selectedOptions as SelectOption[]).map(option => option.value);
                setIsFilterSidebar(true);
                setSelectedFilterPicPipeline(selectedValues);
            } else if (type === "labels") {
                setIsFilterSidebar(true);
                setSelectedFilterLabel((selectedOptions as SelectOption)?.value);
            } else if (type === "status") {
                setIsFilterSidebar(true);
                setSelectedFilterStatus((selectedOptions as SelectOption)?.value);
            } else if (type === "statusSession") {
                const selectedValues = (selectedOptions as SelectOption[]).map(option => option.value);
                setIsFilterSidebar(true);
                setSelectedFilterStatusSession(selectedValues);
            } else if (type === "reset") {
                setIsFilterSidebar(false);
                setSelectedFilterProgress([]);
                setSelectedFilterPicMerchant([]);
                setSelectedFilterPicPipeline([]);
                setSelectedFilterLabel("");
                setSelectedFilterStatus("");
                setSelectedFilterStatusSession([]);
            }
        } else {
            if (type === "labels") {
                setIsGroupFilterSidebar(true);
                setSelectedFilterLabelGroup((selectedOptions as SelectOption)?.value);
            } else if (type === "status") {
                setIsGroupFilterSidebar(true);
                setSelectedFilterStatusGroup((selectedOptions as SelectOption)?.value);
            } else if (type === "reset") {
                setIsGroupFilterSidebar(false);
                setSelectedFilterLabelGroup("");
                setSelectedFilterStatusGroup("");
            }
        }
    };

    const searchResults = useChatSearch(searchSidebar, selectedFilterProgress, selectedFilterLabel, selectedFilterStatus, selectedFilterStatusSession, selectedFilterPicMerchant, selectedFilterPicPipeline);
    const searchGroupResults = useChatGroupSearch(searchGroupSidebar, selectedFilterLabelGroup, selectedFilterStatusGroup);

    useEffect(() => {
        setListFilterChat(searchResults)
    }, [searchResults])

    useEffect(() => {
        setListFilterChatGroup(searchGroupResults)
    }, [searchGroupResults])

    useEffect(() => {
        if (searchSidebar) {
            setMode("search")
        } else {
            setMode("normal")
        }
    }, [searchSidebar])

    useEffect(() => {
        if (searchGroupSidebar) {
            setGroupMode("search")
        } else {
            setGroupMode("normal")
        }
    }, [searchGroupSidebar])

    // Function to debounce the setSearch
    const debounce = <F extends (...args: any[]) => void>(func: F, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        return function (this: any, ...args: Parameters<F>) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    // Debounced setSearch function with a delay of 500 milliseconds (0.5 second)
    const debouncedSetSearchChat = debounce(setSearchSidebar, 500);
    const debouncedSetSearchChatGroup = debounce(setSearchGroupSidebar, 500);

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)

    const fetcherGroupCondiments = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token,
            'X-Chat-Auth-Token': tokenChat,
        }
    }).then(res => res.data.data)

    const { data: progresses = [], isLoading: progressesLoading } = useSWR(`${API_URL}lead_progresses?onlyShowAllowedForCreateLeadLog=true`, fetcher)
    const { data: condiments, isValidating: isValidatingCondiments } = useSWR(Object.keys(listChatRooms).length > 0 ? `${API_URL}v2/chat/condiments` : null, fetcher)
    const keys = Object.keys(listChatRooms).length > 0 ? selectedChatPhone.map((data) => `${API_URL}chat-group/condiments?mode=${chatMode(settings.chat_version)}&as=${data.phone}`) : null;
    const { data: groupCondiments, isValidating: isValidatingGroupCondiments, mutate: mutateGroupCondiments } =
        useSWR(
            keys,
            async (urls: string[]) => {
                const results = await Promise.all(urls.map((url) => fetcherGroupCondiments(url)));
                return results.flat();
            }
        );

    useEffect(() => {
        if (!progressesLoading) {
            const progressesData = progresses
                .map((progress: Progress) => ({
                    value: progress.name,
                    label: progress.name
                }));

            // append the "New" option
            if (user.data.company_id !== companyId.elgisa) {
                const newLabel = checkIsCompanyTanrise(companyId, user) ? intl.formatMessage({ id: "FORM.LABEL.CONTACTED" }) : intl.formatMessage({ id: "FORM.LABEL.NEW" })
                progressesData.push({
                    value: 'NEW',
                    label: newLabel
                })
            }
            setProgressesData(progressesData)
        }
    }, [progresses])

    useEffect(() => {
        if (!userLoading) {
            const usersData = users.map((user: any) => ({
                value: user.name,
                label: user.name
            }));

            setPicData(usersData)
        }
    }, [users])

    useEffect(() => {
        const { listChatRooms } = useChatStore.getState();
        if (!isValidatingCondiments && condiments && listChatRooms) {
            const chatRoomTemp: ListChatRoom = Object.keys(listChatRooms).reduce((acc, key) => {
                const index = condiments.findIndex((condiment: Condiments) => condiment.phone === listChatRooms[key].roomPhone);

                acc[key] = index !== -1
                    ? {
                        ...listChatRooms[key],
                        isMerchantOnly: condiments[index].merchants.length > 0 ? true : false,
                        merchants: condiments[index].merchants,
                        pipelines: condiments[index].leads,
                        labels: condiments[index].labels,
                    }
                    :
                    {
                        ...listChatRooms[key],
                        isMerchantOnly: false,
                        merchants: [],
                        pipelines: [],
                        labels: [],
                    }
                return acc;
            }, {} as ListChatRoom); // Pastikan tipe objek sesuai

            setListChatRooms(() => chatRoomTemp);
        }
    }, [condiments, isValidatingCondiments, lastSynced]);

    useEffect(() => {
        const { listChatGroupRooms, listChatGroupParticipants } = useChatStore.getState();

        if (!isValidatingGroupCondiments && groupCondiments && listChatGroupRooms) {
            // buat map cepat dari groupCondiments agar lookup O(1)
            const condimentMap = new Map<string, GroupCondiments>(
                groupCondiments.map((c: GroupCondiments) => [`${c.id}|${c.as}`, c])
            );

            // iterate berdasarkan urutan key di listChatGroupRooms supaya urutan tetap
            const chatGroupRoomTemp: ListChatGroupRoom = Object.keys(listChatGroupRooms).reduce(
                (acc, key) => {
                    const room = listChatGroupRooms[key];
                    const matchKey = `${room.groupId}|${room.as}`;
                    const condiment = condimentMap.get(matchKey);

                    // kalau tidak ada di condiments → skip (sama seperti logic sebelumnya)
                    if (!condiment) return acc;

                    acc[key] = {
                        ...room,
                        groupDesc: condiment.desc,
                        groupName: condiment.subject,
                        owner: condiment.owner,
                        participants: condiment.participants.map(
                            (participant: ChatGroupParticipants) => {
                                const phone = participant.jid?.replace?.('@s.whatsapp.net', '');
                                const id = participant.id;
                                const lid = participant.lid;

                                if (phone && listChatGroupParticipants[phone]) {
                                    const p = listChatGroupParticipants[phone];
                                    return {
                                        name: p.name,
                                        phone: p.phone,
                                        color: p.color,
                                        lid,
                                    };
                                } else if (id && listChatGroupParticipants[id]) {
                                    const p = listChatGroupParticipants[id];
                                    return {
                                        name: p.name,
                                        phone: p.phone,
                                        color: p.color,
                                        lid,
                                    };
                                } else {
                                    return {
                                        name: phone || id,
                                        phone: phone || id,
                                        color: stringToColor(phone || id),
                                        lid,
                                    };
                                }
                            }
                        ),
                    };

                    return acc;
                },
                {} as ListChatGroupRoom
            );

            setListChatGroupRooms(() => chatGroupRoomTemp);
        }
    }, [groupCondiments, isValidatingGroupCondiments, lastSynced]);

    useEffect(() => {
        const labelsData = chatLabels.map((label: LabelChatProps) => ({
            value: label.id,
            label: label.name,
            color: label.color
        }));

        setLabelsData(labelsData);
    }, [chatLabels]);

    useEffect(() => {
        if (menuActive === "chat") {
            const result = selectChatWindow.reduce((acc, item) => {
                acc[item.phone] = true; // Set boolean value, bisa juga false sesuai kebutuhan
                return acc;
            }, {} as { [phone: string]: boolean });

            setSelected(result)
        } else {
            const result = selectChatGroupWindow.reduce((acc, item) => {
                acc[item.id] = true; // Set boolean value, bisa juga false sesuai kebutuhan
                return acc;
            }, {} as { [phone: string]: boolean });

            setSelected(result)
        }
    }, [showAssignContactLabelModal])

    useModalEffect({
        showModal: showAssignContactLabelModal,
        setShowModal: setShowAssignContactLabelModal,
        modalId: 'assign-contact-label-modal'
    })

    useEffect(() => {
        socket.on("newChat", async (newChat) => {
            const { listChatRooms, listChatMessages, phoneNumber, messages, listChatAgents } = useChatStore.getState();
            let tempChatRooms = { ...listChatRooms };
            let tempChatMessages = { ...listChatMessages };
            let key = `${newChat.roomPhone}-${newChat.as}`;
            const indexMessage = tempChatMessages[key]?.findIndex((chat) => chat.id === newChat.chats[0].id)

            setSelectedChatPhone((prev) => prev.map((item) => (
                item.phone === newChat.as ? { ...item, newDateChat: newChat.chats[0].receivedAt } : item
            )));

            let tempChat = {
                ...newChat.chats[0] || null,
                phone: newChat.roomPhone,
                as: newChat.as,
                action: {
                    isEditing: false
                }
            }

            if (indexMessage !== -1 && indexMessage !== undefined) {
                setMessages((prevMessages) => {
                    if (!prevMessages[indexMessage]) return prevMessages; // Hindari error jika index tidak valid

                    if (phoneNumber === key) {
                        const updatedMessages = [...prevMessages];
                        updatedMessages[indexMessage] = tempChat

                        let sortedPart = updatedMessages.splice(indexMessage).sort((a, b) =>
                            new Date(a.receivedAt).getTime() - new Date(b.receivedAt).getTime()
                        );
                        updatedMessages.push(...sortedPart);
                        return updatedMessages;
                    }

                    return prevMessages;
                });

                tempChatRooms[key] = {
                    ...tempChatRooms[key],
                    chat: tempChat,
                    isMerchantOnly: newChat.isMerchantOnly,
                }

                const worker = new Worker(new URL('../../app/pages/chat/SortChatRoomWorker.ts', import.meta.url));
                worker.postMessage({ data: tempChatRooms });
                worker.onmessage = (event) => {
                    const { data } = event.data;
                    setListChatRooms(() => data);
                    worker.terminate();
                };

                setListChatMessages((prevMessages) => {
                    const updatedMessages = { ...prevMessages };
                    updatedMessages[key][indexMessage] = tempChat

                    let sortedPart = updatedMessages[key].splice(indexMessage).sort((a, b) =>
                        new Date(a.receivedAt).getTime() - new Date(b.receivedAt).getTime()
                    );
                    updatedMessages[key].push(...sortedPart);
                    return updatedMessages;
                })
            } else {
                if (!tempChatRooms[key]) {
                    tempChatRooms[key] = {
                        as: newChat.as,
                        roomPhone: newChat.roomPhone,
                        roomName: newChat.roomName ? newChat.roomName : newChat.roomPhone,
                        isMerchantOnly: newChat.isMerchantOnly,
                        chat: tempChat,
                        labels: [],
                        merchants: [],
                        pipelines: [],
                        color: selectedChatPhone.find((item) => item.phone === newChat.as)?.color!,
                        connected: true,
                        selected: false,
                        loading: false,
                    }
                } else {
                    tempChatRooms[key] = {
                        ...tempChatRooms[key],
                        chat: tempChat,
                        isMerchantOnly: newChat.isMerchantOnly,
                    }
                }

                if (!tempChatMessages[key]) {
                    tempChatMessages[key] = [tempChat]
                } else {
                    tempChatMessages[key] = [...tempChatMessages[key], tempChat]
                }

                // const worker = new Worker(new URL('../../app/pages/chat/SortChatRoomWorker.ts', import.meta.url));
                // worker.postMessage({ data: tempChatRooms });
                // worker.onmessage = (event) => {
                //     const { data } = event.data;
                //     setListChatRooms(() => data);
                //     worker.terminate();
                // };

                let sortRooms = sortChatRooms(tempChatRooms)
                setListChatRooms(() => sortRooms);
                if (phoneNumber === key) {
                    setMessages(() => [...messages, tempChat])
                }

                setListChatMessages(() => tempChatMessages);
            }

            if (!newChat.chats[0].fromMe && phoneNumber !== key && isShowChatRoom(settings, listChatAgents, tempChatRooms[key], user)) {
                let tempRoom: ChatRoom = {
                    as: newChat.as,
                    roomName: tempChatRooms[key].roomName ? tempChatRooms[key].roomName : tempChatRooms[key].roomPhone,
                    roomPhone: newChat.roomPhone,
                    labels: tempChatRooms[key].labels ? tempChatRooms[key].labels : [],
                    merchants: tempChatRooms[key].merchants ? tempChatRooms[key].merchants : [],
                    pipelines: tempChatRooms[key].pipelines ? tempChatRooms[key].pipelines : [],
                    isMerchantOnly: newChat.isMerchantOnly,
                    chat: tempChat,
                    color: selectedChatPhone.find((item) => item.phone === newChat.as)?.color!,
                    connected: true,
                    selected: false,
                    loading: false,
                }

                setTimeout(() => handleChatNotification(tempRoom), 0)

                setMessageNotifications((prevNotifications) => {
                    const prev = prevNotifications[key];
                    const latestId = newChat.chats[0].id;

                    return {
                        ...prevNotifications,
                        [key]: {
                            ...prev,
                            idLatestMessage: latestId,
                            latestMessage: newChat.chats[0].message,
                            unreadCount: prev?.idLatestMessage === latestId ? prev?.unreadCount || 0 : (prev?.unreadCount || 0) + 1,
                        },
                    };
                });
            }
        })

        socket.on("newGroupChat", async (newGroupChat) => {
            const { listChatGroupRooms, listChatGroupMessages, groupID, groupMessages } = useChatStore.getState();
            let tempChatGroupRooms = { ...listChatGroupRooms };
            let tempChatGroupMessages = { ...listChatGroupMessages };
            let key = `${newGroupChat.id}|${newGroupChat.as}`;
            const indexMessage = tempChatGroupMessages[key]?.findIndex((chat) => chat.id === newGroupChat.chats[0].id)

            setSelectedChatPhone((prev) => prev.map((item) => (
                item.phone === newGroupChat.as ? { ...item, newDateChatGroup: newGroupChat.chats[0].receivedAt } : item
            )));

            let tempChat = {
                ...newGroupChat.chats[0] || null,
                as: newGroupChat.as,
                action: {
                    isEditing: false
                }
            }

            if (indexMessage !== -1 && indexMessage !== undefined) {
                setGroupMessages((prevMessages) => {
                    if (!prevMessages[indexMessage]) return prevMessages; // Hindari error jika index tidak valid

                    if (groupID === key) {
                        const updatedMessages = [...prevMessages];
                        updatedMessages[indexMessage] = tempChat

                        let sortedPart = updatedMessages.splice(indexMessage).sort((a, b) =>
                            new Date(a.receivedAt).getTime() - new Date(b.receivedAt).getTime()
                        );
                        updatedMessages.push(...sortedPart);
                        return updatedMessages;
                    }

                    return prevMessages;
                });

                tempChatGroupRooms[key] = {
                    ...tempChatGroupRooms[key],
                    chat: tempChat,
                }

                const worker = new Worker(new URL('../../app/pages/chat/SortChatRoomWorker.ts', import.meta.url));
                worker.postMessage({ data: tempChatGroupRooms });
                worker.onmessage = (event) => {
                    const { data } = event.data;
                    setListChatGroupRooms(() => data);
                    worker.terminate();
                };

                setListChatGroupMessages((prevMessages) => {
                    const updatedMessages = { ...prevMessages };
                    updatedMessages[key][indexMessage] = tempChat

                    let sortedPart = updatedMessages[key].splice(indexMessage).sort((a, b) =>
                        new Date(a.receivedAt).getTime() - new Date(b.receivedAt).getTime()
                    );
                    updatedMessages[key].push(...sortedPart);
                    return updatedMessages;
                })
            } else {
                mutateGroupCondiments()
                if (!tempChatGroupRooms[key]) {
                    tempChatGroupRooms[key] = {
                        as: newGroupChat.as,
                        groupId: newGroupChat.id,
                        groupName: '',
                        groupDesc: '',
                        chat: tempChat,
                        labels: [],
                        color: selectedChatPhone.find((item) => item.phone === newGroupChat.as)?.color!,
                        connected: true,
                        selected: false,
                        loading: false,
                        owner: '',
                        participants: []
                    }
                } else {
                    tempChatGroupRooms[key] = {
                        ...tempChatGroupRooms[key],
                        chat: tempChat,
                    }
                }

                if (!tempChatGroupMessages[key]) {
                    tempChatGroupMessages[key] = [tempChat]
                } else {
                    tempChatGroupMessages[key] = [...tempChatGroupMessages[key], tempChat]
                }

                // const worker = new Worker(new URL('../../app/pages/chat/SortChatRoomWorker.ts', import.meta.url));
                // worker.postMessage({ data: tempChatGroupRooms });
                // worker.onmessage = (event) => {
                //     const { data } = event.data;
                //     setListChatRooms(() => data);
                //     worker.terminate();
                // };

                let sortRooms = sortChatRooms(tempChatGroupRooms)
                setListChatGroupRooms(() => sortRooms);
                if (groupID === key) {
                    setGroupMessages(() => [...groupMessages, tempChat])
                }

                setListChatGroupMessages(() => tempChatGroupMessages);
            }

            if (!newGroupChat.chats[0].fromMe && groupID !== key) {
                let tempGroupRoom: ChatGroupRoom = {
                    as: newGroupChat.as,
                    groupName: tempChatGroupRooms[key].groupName ? tempChatGroupRooms[key].groupName : '',
                    groupId: newGroupChat.id,
                    groupDesc: tempChatGroupRooms[key].groupDesc,
                    labels: tempChatGroupRooms[key].labels ? tempChatGroupRooms[key].labels : [],
                    chat: tempChat,
                    color: selectedChatPhone.find((item) => item.phone === newGroupChat.as)?.color!,
                    connected: true,
                    selected: false,
                    loading: false,
                    owner: tempChatGroupRooms[key].owner,
                    participants: tempChatGroupRooms[key].participants
                }

                setTimeout(() => handleChatGroupNotification(tempGroupRoom), 0)

                setGroupMessageNotifications((prevNotifications) => {
                    const updatedNotifications = { ...prevNotifications };

                    if (!newGroupChat.chats[0].fromMe) {
                        updatedNotifications[key] = [
                            ...(updatedNotifications[key] ?? []),
                            {
                                idLatestMessage: newGroupChat.chats[0].id,
                                latestMessage: newGroupChat.chats[0].message,
                            },
                        ];
                    }

                    return updatedNotifications;
                });
            }
        })

        const getSessionHistoryURL = () => {
            const { selectedChatPhone, phoneNumber, startDateSession, endDateSession } = useChatStore.getState();
            if (settings.chat_version === 'v2') {
                const queryParams = [
                    ...selectedChatPhone.map(phone => `phonesId[]=${encodeURIComponent(phone.id)}`),
                    `customerPhone=${encodeURIComponent(phoneNumber.split('-')[0])}`,
                    `dateStartFrom=${encodeURIComponent(moment(startDateSession).toISOString())}`,
                    `dateStartTo=${encodeURIComponent(isToday(parseISO(moment(endDateSession).toISOString())) ? moment(endDateSession).add(1, 'days').toISOString() : moment(endDateSession).toISOString())}`
                ].join('&');

                if (user.data.is_superadmin) return `${API_URL}chat-agent/admin/sessions?${queryParams}`
                else return `${API_URL}chat-agent/agent/sessions?${queryParams}`
            } else return null
        }

        const updateSessionChat = (session: ChatAgent) => {
            const { listChatAgents, phoneNumber, setListChatAgents } = useChatStore.getState();
            let tempChatAgents = { ...listChatAgents };
            const key = `${session.phone}-${session.agent.phone}`
            tempChatAgents[key][tempChatAgents[key].length - 1] = session
            setListChatAgents(() => tempChatAgents)

            if (phoneNumber) mutate(getSessionHistoryURL())
        }

        socket.on("sessionTaken", async (session) => {
            const { listChatAgents, setListChatAgents, phoneNumber, setPhoneNumber, setIsOpenDetailContact, setShowChat } = useChatStore.getState();
            let tempChatAgents = { ...listChatAgents };
            const key = `${session.phone}-${session.agent.phone}`
            if (phoneNumber === key) {
                if (session.handler.id !== user.data.id) {
                    setShowChat(false)
                    setIsOpenDetailContact(false)
                    setPhoneNumber('')
                }
            }

            let index = 0
            if (!tempChatAgents[key]) tempChatAgents[key] = [];
            else index = tempChatAgents[key].length

            tempChatAgents[key][index] = session
            setListChatAgents(() => tempChatAgents)
            if (phoneNumber) mutate(getSessionHistoryURL())
        })

        socket.on("sessionEnded", async (session) => {
            updateSessionChat(session)
        })

        socket.on("sessionTimedOut", async (session) => {
            updateSessionChat(session)
        })

        socket.on("sessionStateUpdated", async (session) => {
            updateSessionChat(session)
        })

        socket.on("sessionHandlerSwitched", async (session) => {
            updateSessionChat(session)
        })

        socket.on("merchantOwnerChanged", async (data) => {
            const { listChatRooms, setListChatRooms, selectedChatPhone, setIsSyncRoom, phoneNumber, setPhoneNumber, setShowChat } = useChatStore.getState();
            const tempChatRooms = { ...listChatRooms };

            if (data.phone === phoneNumber.split('-')[0]) {
                setShowChat(false)
                setPhoneNumber('')
                setIsOpenDetailContact(false)
            }

            selectedChatPhone.forEach((item) => {
                const roomKey = `${data.phone}-${item.phone}`;
                const dataMerchant = tempChatRooms[roomKey];

                if (!dataMerchant) {
                    let newData = {
                        id: "",
                        message: "",
                        receivedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
                        attachmentName: null,
                        updatedAt: null,
                        fromMe: false,
                        idReference: null,
                        isForwarded: false,
                        isJMessageAvailable: false,
                        sender: null,
                        phone: data.phone,
                        as: item.phone,
                        action: {
                            isEditing: false
                        }
                    }

                    setIsSyncRoom(() => true)
                    handleIntSync(false, true, 'chat', newData as ChatMessage);
                }
                
                mutate(`${API_URL}v2/chat/condiments`)
            });

            setListChatRooms(() => tempChatRooms);
        });

        return () => {
            socket.off("newChat");
            socket.off("sessionTaken");
            socket.off("sessionEnded");
            socket.off("sessionTimedOut");
            socket.off("sessionStateUpdated");
            socket.off("sessionHandlerSwitched");
            socket.off("merchantOwnerChanged");
        }
    }, [socket])

    useEffect(() => {
        setStatusData([{ value: 'unread', label: 'Belum dibaca' }, { value: 'read', label: 'Dibaca' }])
        setStatusSessionData([{ value: 'active', label: 'Active' }, { value: 'waiting', label: 'Waiting' }, { value: 'unassigned', label: 'Not Taken' }])

        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                dropdownRef.current.querySelector(".dropdown-menu")?.classList.remove("show");
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const CustomOption = (props: any) => {
        return (
            <components.Option {...props}>
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'wrap' }}>
                    <svg viewBox="0 0 24 24" height="20" width="20" className="cursor-pointer me-2" preserveAspectRatio="xMidYMid meet" fill="none" style={{ color: props.data.color, width: '20px', flexShrink: 0, marginBottom: "auto" }}>
                        <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z"></path>
                    </svg>
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {props.data.label}
                    </span>
                </div>
            </components.Option>
        );
    };

    const CustomSingleValue = (props: any) => {
        return (
            <components.SingleValue {...props}>
                <svg viewBox="0 0 24 24" height="20" width="20" className="cursor-pointer me-2" preserveAspectRatio="xMidYMid meet" fill="none" style={{ color: props.data.color }}>
                    <path fill="currentColor" fillRule="evenodd" clip-rule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z"></path>
                </svg>
                {props.data.label}
            </components.SingleValue>
        );
    };

    const isUseFilter = () => {
        if (menuActive === "chat") {
            if (selectedFilterLabel || selectedFilterStatus || selectedFilterStatusSession.length > 0 || selectedFilterProgress.length > 0 || selectedFilterPicMerchant.length > 0 || selectedFilterPicPipeline.length > 0) return true
            else return false
        } else {
            if (selectedFilterLabelGroup || selectedFilterStatusGroup) return true
            else return false
        }
    }

    return (
        <div className='card card-flush w-100' style={{ maxHeight: "calc(100vh - 1rem)", height: "calc(100vh - 1rem)", ...style }}>
            <div className="d-flex align-items-center justify-content-between p-3 pb-0">
                <h1 className="mb-0 text-dark fw-bolder fs-1">{menuActive === "chat" ? 'Chat' : 'Grup Chat'}</h1>
                {
                    settings.chat_version !== 'v2' && (user.data.is_superadmin || settings.can_init_chat) && selectedChatPhone.length === 1 &&
                    <i className="fas fa-comment-medical fs-2 cursor-pointer" onClick={() => setMenuActive("initiate-chat")} style={{ paddingRight: "12px" }}></i>
                }
            </div>
            {
                connected &&
                <>
                    {
                        menuActive === "chat" &&
                        <div className="px-3">
                            {
                                ((settings.chat_show_pic_only && !user.data.is_superadmin) || (settings.chat_superadmin_merchant_only && user.data.is_superadmin)) &&
                                <span className="badge badge-primary">
                                    Merchants only
                                </span>
                            }
                        </div>
                    }
                    {
                        menuActive === "chat" ?
                            <div className="card-header p-3" style={{ background: "white" }}>
                                {
                                    selectChatWindow.length === 0 ?
                                        <div className="w-100 d-flex gap-2">
                                            <form className='w-100 position-relative' autoComplete='off'>
                                                <span className="svg-icon svg-icon-1 position-absolute ms-6 mt-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                                    </svg>
                                                </span>
                                                <input
                                                    type="search"
                                                    className="form-control form-control-solid ps-15"
                                                    placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') e.preventDefault()
                                                    }}
                                                    style={{ borderRadius: "50px" }}
                                                    onChange={(e) => debouncedSetSearchChat(e.target.value)}
                                                />
                                            </form>
                                            <div className='dropdown' ref={dropdownRef}>
                                                <button style={isUseFilter() ? { backgroundColor: "#f1faff" } : {}} type="button" className={`${!isUseFilter() && 'btn-white'} btn btn-icon dropdown-toggle`} data-bs-toggle="dropdown" aria-expanded="false">
                                                    <KTSVG path='/media/icons/duotune/general/gen031.svg' className={`${isUseFilter() && 'svg-icon-primary'} svg-icon-2 m-0`} />
                                                </button>
                                                <div className='dropdown-menu p-0' style={{ maxWidth: '250px' }} onClick={(e) => e.stopPropagation()}>
                                                    <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 show" style={{ width: '250px' }}>
                                                        <div className="menu-item px-3">
                                                            <div className="px-2 d-flex justify-content-between align-items-center">
                                                                <span className="fs-5">Filter</span>
                                                                {
                                                                    isUseFilter() &&
                                                                    <button className="btn btn-sm btn-light-primary" onClick={() => handleFilterChange({} as SelectOption, 'reset')}>Reset</button>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="separator my-2"></div>
                                                        <div className="menu-item px-3">
                                                            <Select
                                                                styles={{
                                                                    control: (baseStyles, state) => ({
                                                                        ...baseStyles,
                                                                        borderColor: "#F5F8FA",
                                                                        backgroundColor: "#F5F8FA",
                                                                        borderRadius: "0.475rem",
                                                                        width: "100%",
                                                                        boxShadow: 'none',
                                                                        '&:hover': {
                                                                            borderColor: "#F5F8FA",
                                                                            backgroundColor: "#F5F8FA",
                                                                        },
                                                                    }),
                                                                    option: (baseStyles, { isSelected, isFocused }) => ({
                                                                        ...baseStyles,
                                                                        backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                        cursor: 'pointer',
                                                                        zIndex: 99
                                                                    }),
                                                                    indicatorSeparator: (baseStyles, state) => ({
                                                                        ...baseStyles,
                                                                        display: 'none',
                                                                    }),
                                                                }}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary: 'none',
                                                                    },
                                                                })}
                                                                value={statusData.filter((opt) => opt.value === selectedFilterStatus)}
                                                                isClearable={true}
                                                                closeMenuOnSelect={true}
                                                                placeholder={`Status`}
                                                                onChange={(option) => handleFilterChange(option as SelectOption, "status")}
                                                                options={statusData}
                                                                className="my-2"
                                                            />

                                                            <Select
                                                                styles={{
                                                                    control: (baseStyles, state) => ({
                                                                        ...baseStyles,
                                                                        borderColor: "#F5F8FA",
                                                                        backgroundColor: "#F5F8FA",
                                                                        borderRadius: "0.475rem",
                                                                        width: "100%",
                                                                        boxShadow: 'none',
                                                                        '&:hover': {
                                                                            borderColor: "#F5F8FA",
                                                                            backgroundColor: "#F5F8FA",
                                                                        },
                                                                    }),
                                                                    option: (baseStyles, { isSelected, isFocused }) => ({
                                                                        ...baseStyles,
                                                                        backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                        cursor: 'pointer',
                                                                        zIndex: 99
                                                                    }),
                                                                    indicatorSeparator: (baseStyles, state) => ({
                                                                        ...baseStyles,
                                                                        display: 'none',
                                                                    }),
                                                                    valueContainer: (baseStyles, state) => ({
                                                                        ...baseStyles,
                                                                        overflowY: 'auto',  // Mengaktifkan scroll horizontal
                                                                        maxHeight: '80px', // Atur lebar maksimal agar tidak melebihi batas tertentu
                                                                        scrollbarWidth: "thin", // Untuk Firefox
                                                                        scrollbarColor: "#d1d1d1 transparent", // Untuk Firefox
                                                                        "&::-webkit-scrollbar": {
                                                                            height: "4px", // Tinggi scrollbar
                                                                        },
                                                                        "&::-webkit-scrollbar-thumb": {
                                                                            backgroundColor: "#d1d1d1", // Warna scroll thumb
                                                                        },
                                                                    }),
                                                                }}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary: 'none',
                                                                    },
                                                                })}
                                                                isMulti
                                                                value={progressesData.filter((opt) => selectedFilterProgress.includes(opt.value))}
                                                                closeMenuOnSelect={false}
                                                                placeholder={`Progress ${settings.pipeline_title}`}
                                                                onChange={(option) => handleFilterChange(option as SelectOption[], "progress")}
                                                                options={progressesData}
                                                                className="my-2"
                                                                isLoading={progressesLoading}
                                                            />

                                                            {
                                                                labelsData.length > 0 &&
                                                                <Select
                                                                    styles={{
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: "#F5F8FA",
                                                                            backgroundColor: "#F5F8FA",
                                                                            borderRadius: "0.475rem",
                                                                            width: "100%",
                                                                            boxShadow: 'none',
                                                                            '&:hover': {
                                                                                borderColor: "#F5F8FA",
                                                                                backgroundColor: "#F5F8FA",
                                                                            },
                                                                        }),
                                                                        option: (baseStyles, { isSelected, isFocused }) => ({
                                                                            ...baseStyles,
                                                                            backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                            cursor: 'pointer',
                                                                            zIndex: 99
                                                                        }),
                                                                        indicatorSeparator: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            display: 'none',
                                                                        }),
                                                                    }}
                                                                    theme={(theme) => ({
                                                                        ...theme,
                                                                        colors: {
                                                                            ...theme.colors,
                                                                            primary: 'none',
                                                                        },
                                                                    })}
                                                                    isClearable={true}
                                                                    closeMenuOnSelect={true}
                                                                    value={labelsData.filter((opt) => opt.value === selectedFilterLabel)}
                                                                    placeholder={intl.formatMessage({ id: "FORM.LABEL.LABELS" })}
                                                                    onChange={(option) => handleFilterChange(option as SelectOption, "labels")}
                                                                    options={labelsData}
                                                                    components={{
                                                                        Option: CustomOption,
                                                                        SingleValue: CustomSingleValue,
                                                                    }}
                                                                    className="my-2"
                                                                />
                                                            }

                                                            {
                                                                settings.chat_show_merchant_pic &&
                                                                <Select
                                                                    styles={{
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: "#F5F8FA",
                                                                            backgroundColor: "#F5F8FA",
                                                                            borderRadius: "0.475rem",
                                                                            width: "100%",
                                                                            boxShadow: 'none',
                                                                            '&:hover': {
                                                                                borderColor: "#F5F8FA",
                                                                                backgroundColor: "#F5F8FA",
                                                                            },
                                                                        }),
                                                                        option: (baseStyles, { isSelected, isFocused }) => ({
                                                                            ...baseStyles,
                                                                            backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                            cursor: 'pointer',
                                                                            zIndex: 99
                                                                        }),
                                                                        indicatorSeparator: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            display: 'none',
                                                                        }),
                                                                        valueContainer: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            overflowY: 'auto',  // Mengaktifkan scroll horizontal
                                                                            maxHeight: '80px', // Atur lebar maksimal agar tidak melebihi batas tertentu
                                                                            scrollbarWidth: "thin", // Untuk Firefox
                                                                            scrollbarColor: "#d1d1d1 transparent", // Untuk Firefox
                                                                            "&::-webkit-scrollbar": {
                                                                                height: "4px", // Tinggi scrollbar
                                                                            },
                                                                            "&::-webkit-scrollbar-thumb": {
                                                                                backgroundColor: "#d1d1d1", // Warna scroll thumb
                                                                            },
                                                                        }),
                                                                    }}
                                                                    theme={(theme) => ({
                                                                        ...theme,
                                                                        colors: {
                                                                            ...theme.colors,
                                                                            primary: 'none',
                                                                        },
                                                                    })}
                                                                    isMulti
                                                                    value={picData.filter((opt) => selectedFilterPicMerchant.includes(opt.value))}
                                                                    closeMenuOnSelect={false}
                                                                    placeholder={`PIC ${settings.merchant_title}`}
                                                                    onChange={(option) => handleFilterChange(option as SelectOption[], "picMerchant")}
                                                                    options={picData}
                                                                    className="my-2"
                                                                />
                                                            }
                                                            {
                                                                settings.chat_show_lead_pic &&
                                                                <Select
                                                                    styles={{
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: "#F5F8FA",
                                                                            backgroundColor: "#F5F8FA",
                                                                            borderRadius: "0.475rem",
                                                                            width: "100%",
                                                                            boxShadow: 'none',
                                                                            '&:hover': {
                                                                                borderColor: "#F5F8FA",
                                                                                backgroundColor: "#F5F8FA",
                                                                            },
                                                                        }),
                                                                        option: (baseStyles, { isSelected, isFocused }) => ({
                                                                            ...baseStyles,
                                                                            backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                            cursor: 'pointer',
                                                                            zIndex: 99
                                                                        }),
                                                                        indicatorSeparator: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            display: 'none',
                                                                        }),
                                                                        valueContainer: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            overflowY: 'auto',  // Mengaktifkan scroll horizontal
                                                                            maxHeight: '80px', // Atur lebar maksimal agar tidak melebihi batas tertentu
                                                                            scrollbarWidth: "thin", // Untuk Firefox
                                                                            scrollbarColor: "#d1d1d1 transparent", // Untuk Firefox
                                                                            "&::-webkit-scrollbar": {
                                                                                height: "4px", // Tinggi scrollbar
                                                                            },
                                                                            "&::-webkit-scrollbar-thumb": {
                                                                                backgroundColor: "#d1d1d1", // Warna scroll thumb
                                                                            },
                                                                        }),
                                                                    }}
                                                                    theme={(theme) => ({
                                                                        ...theme,
                                                                        colors: {
                                                                            ...theme.colors,
                                                                            primary: 'none',
                                                                        },
                                                                    })}
                                                                    isMulti
                                                                    value={picData.filter((opt) => selectedFilterPicPipeline.includes(opt.value))}
                                                                    closeMenuOnSelect={false}
                                                                    placeholder={`PIC ${settings.pipeline_title}`}
                                                                    onChange={(option) => handleFilterChange(option as SelectOption[], "picPipeline")}
                                                                    options={picData}
                                                                    className="my-2"
                                                                />
                                                            }
                                                            {
                                                                settings.chat_version === 'v2' &&
                                                                <Select
                                                                    styles={{
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: "#F5F8FA",
                                                                            backgroundColor: "#F5F8FA",
                                                                            borderRadius: "0.475rem",
                                                                            width: "100%",
                                                                            boxShadow: 'none',
                                                                            '&:hover': {
                                                                                borderColor: "#F5F8FA",
                                                                                backgroundColor: "#F5F8FA",
                                                                            },
                                                                        }),
                                                                        option: (baseStyles, { isSelected, isFocused }) => ({
                                                                            ...baseStyles,
                                                                            backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                            cursor: 'pointer',
                                                                            zIndex: 99
                                                                        }),
                                                                        indicatorSeparator: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            display: 'none',
                                                                        }),
                                                                        valueContainer: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            overflowY: 'auto',  // Mengaktifkan scroll horizontal
                                                                            maxHeight: '80px', // Atur lebar maksimal agar tidak melebihi batas tertentu
                                                                            scrollbarWidth: "thin", // Untuk Firefox
                                                                            scrollbarColor: "#d1d1d1 transparent", // Untuk Firefox
                                                                            "&::-webkit-scrollbar": {
                                                                                height: "4px", // Tinggi scrollbar
                                                                            },
                                                                            "&::-webkit-scrollbar-thumb": {
                                                                                backgroundColor: "#d1d1d1", // Warna scroll thumb
                                                                            },
                                                                        }),
                                                                    }}
                                                                    theme={(theme) => ({
                                                                        ...theme,
                                                                        colors: {
                                                                            ...theme.colors,
                                                                            primary: 'none',
                                                                        },
                                                                    })}
                                                                    isMulti
                                                                    value={statusSessionData.filter((opt) => selectedFilterStatusSession.includes(opt.value))}
                                                                    isClearable={true}
                                                                    closeMenuOnSelect={false}
                                                                    placeholder={`Status Sesi`}
                                                                    onChange={(option) => handleFilterChange(option as SelectOption[], "statusSession")}
                                                                    options={statusSessionData}
                                                                    className="my-2"
                                                                />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="px-2 d-flex align-items-center justify-content-between w-100">
                                            <div className="d-flex align-items-center gap-5">
                                                <i className="p-3 cursor-pointer fas fa-times fs-3" onClick={() => setSelectChatWindow([])}></i>
                                                <div className="mb-0 text-dark fs-3">{selectChatWindow.length} {intl.formatMessage({ id: "FORM.LABEL.SELECTED_DATA" })}</div>
                                            </div>
                                            <svg onClick={() => setShowAssignContactLabelModal(true)} viewBox="0 0 24 24" height="24" width="24" className="cursor-pointer me-3" preserveAspectRatio="xMidYMid meet" fill="none" style={{ color: "#a1a5b7" }}>
                                                <path fill="currentColor" fillRule="evenodd" clip-rule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z"></path>
                                            </svg>
                                        </div>
                                }
                            </div>
                            :
                            <div className="card-header p-3" style={{ background: "white" }}>
                                {
                                    selectChatGroupWindow.length === 0 ?
                                        <div className="w-100 d-flex gap-2">
                                            <form className='w-100 position-relative' autoComplete='off'>
                                                <span className="svg-icon svg-icon-1 position-absolute ms-6 mt-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                                    </svg>
                                                </span>
                                                <input
                                                    type="search"
                                                    className="form-control form-control-solid ps-15"
                                                    placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') e.preventDefault()
                                                    }}
                                                    style={{ borderRadius: "50px" }}
                                                    onChange={(e) => debouncedSetSearchChatGroup(e.target.value)}
                                                />
                                            </form>
                                            <div className='dropdown' ref={dropdownRef}>
                                                <button style={isUseFilter() ? { backgroundColor: "#f1faff" } : {}} type="button" className={`${!isUseFilter() && 'btn-white'} btn btn-icon dropdown-toggle`} data-bs-toggle="dropdown" aria-expanded="false">
                                                    <KTSVG path='/media/icons/duotune/general/gen031.svg' className={`${isUseFilter() && 'svg-icon-primary'} svg-icon-2 m-0`} />
                                                </button>
                                                <div className='dropdown-menu p-0' style={{ maxWidth: '250px' }} onClick={(e) => e.stopPropagation()}>
                                                    <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 show" style={{ width: '250px' }}>
                                                        <div className="menu-item px-3">
                                                            <div className="px-2 d-flex justify-content-between align-items-center">
                                                                <span className="fs-5">Filter</span>
                                                                {
                                                                    isUseFilter() &&
                                                                    <button className="btn btn-sm btn-light-primary" onClick={() => handleFilterChange({} as SelectOption, 'reset')}>Reset</button>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="separator my-2"></div>
                                                        <div className="menu-item px-3">
                                                            <Select
                                                                styles={{
                                                                    control: (baseStyles, state) => ({
                                                                        ...baseStyles,
                                                                        borderColor: "#F5F8FA",
                                                                        backgroundColor: "#F5F8FA",
                                                                        borderRadius: "0.475rem",
                                                                        width: "100%",
                                                                        boxShadow: 'none',
                                                                        '&:hover': {
                                                                            borderColor: "#F5F8FA",
                                                                            backgroundColor: "#F5F8FA",
                                                                        },
                                                                    }),
                                                                    option: (baseStyles, { isSelected, isFocused }) => ({
                                                                        ...baseStyles,
                                                                        backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                        cursor: 'pointer',
                                                                        zIndex: 99
                                                                    }),
                                                                    indicatorSeparator: (baseStyles, state) => ({
                                                                        ...baseStyles,
                                                                        display: 'none',
                                                                    }),
                                                                }}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary: 'none',
                                                                    },
                                                                })}
                                                                value={statusData.filter((opt) => opt.value === selectedFilterStatusGroup)}
                                                                isClearable={true}
                                                                closeMenuOnSelect={true}
                                                                placeholder={`Status`}
                                                                onChange={(option) => handleFilterChange(option as SelectOption, "status")}
                                                                options={statusData}
                                                                className="my-2"
                                                            />

                                                            {/* {
                                                                labelsData.length > 0 &&
                                                                <Select
                                                                    styles={{
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: "#F5F8FA",
                                                                            backgroundColor: "#F5F8FA",
                                                                            borderRadius: "0.475rem",
                                                                            width: "100%",
                                                                            boxShadow: 'none',
                                                                            '&:hover': {
                                                                                borderColor: "#F5F8FA",
                                                                                backgroundColor: "#F5F8FA",
                                                                            },
                                                                        }),
                                                                        option: (baseStyles, { isSelected, isFocused }) => ({
                                                                            ...baseStyles,
                                                                            backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                            cursor: 'pointer',
                                                                            zIndex: 99
                                                                        }),
                                                                        indicatorSeparator: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            display: 'none',
                                                                        }),
                                                                    }}
                                                                    theme={(theme) => ({
                                                                        ...theme,
                                                                        colors: {
                                                                            ...theme.colors,
                                                                            primary: 'none',
                                                                        },
                                                                    })}
                                                                    isClearable={true}
                                                                    closeMenuOnSelect={true}
                                                                    value={labelsData.filter((opt) => opt.value === selectedFilterLabelGroup)}
                                                                    placeholder={intl.formatMessage({ id: "FORM.LABEL.LABELS" })}
                                                                    onChange={(option) => handleFilterChange(option as SelectOption, "labels")}
                                                                    options={labelsData}
                                                                    components={{
                                                                        Option: CustomOption,
                                                                        SingleValue: CustomSingleValue,
                                                                    }}
                                                                    className="my-2"
                                                                />
                                                            } */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="px-2 d-flex align-items-center justify-content-between w-100">
                                            <div className="d-flex align-items-center gap-5">
                                                <i className="p-3 cursor-pointer fas fa-times fs-3" onClick={() => setSelectChatGroupWindow([])}></i>
                                                <div className="mb-0 text-dark fs-3">{selectChatGroupWindow.length} {intl.formatMessage({ id: "FORM.LABEL.SELECTED_DATA" })}</div>
                                            </div>
                                            <svg onClick={() => setShowAssignContactLabelModal(true)} viewBox="0 0 24 24" height="24" width="24" className="cursor-pointer me-3" preserveAspectRatio="xMidYMid meet" fill="none" style={{ color: "#a1a5b7" }}>
                                                <path fill="currentColor" fillRule="evenodd" clip-rule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z"></path>
                                            </svg>
                                        </div>
                                }
                            </div>
                    }
                    {
                        menuActive === "chat" ?
                            <div className="card-body px-3 pt-0" style={{ height: '100%' }}>
                                {
                                    isWaitingForNetwork ?
                                        <div id="sync-label" className="text-center">
                                            <span className="badge badge-light-warning fs-7 fw-bold">
                                                Waiting for network...
                                            </span>
                                        </div>
                                        : isSyncing ?
                                            <div id="sync-label" className="text-center">
                                                <span className="badge badge-light-primary fs-7 fw-bold">
                                                    Synchronizing
                                                </span>
                                            </div>
                                            : <></>
                                }
                                {
                                    searchSidebar || isFilterSidebar ?
                                        <ChatListSearch />
                                        :
                                        <ChatList />
                                }
                            </div>
                            :
                            <div className="card-body px-3 pt-0" style={{ height: '100%' }}>
                                {
                                    isWaitingForNetwork ?
                                        <div id="sync-label" className="text-center">
                                            <span className="badge badge-light-warning fs-7 fw-bold">
                                                Waiting for network...
                                            </span>
                                        </div>
                                        : isGroupSyncing ?
                                            <div id="sync-label" className="text-center">
                                                <span className="badge badge-light-primary fs-7 fw-bold">
                                                    Synchronizing
                                                </span>
                                            </div>
                                            : <></>
                                }
                                {
                                    searchGroupSidebar || isGroupFilterSidebar ?
                                        <ChatGroupListSearch />
                                        :
                                        <ChatGroupList />
                                }
                            </div>
                    }
                </>
            }

            {
                showAssignContactLabelModal && <AssignContactLabel dataSelect={selected} setSelected={setSelected} />
            }
        </div>
    )
}

export { ChatSidebar }